import React, { Component } from 'react'
import { Spin } from 'antd'

class LoadingSpinner extends Component {
  render() {
    return (
      <div className="spin-ontainer">
        <div className="center-spin">
          <Spin size="large" />
        </div>
      </div>
    )
  }
}

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js